/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ComponentSelectInput from '../../../../../Common/ComponentSelectInput';
import ComponentTextInput from '../../../../../Common/ComponentTextinput/ComponentTextInput';
import CustomCheckbox from '../../../../../Common/ComponentCustomCheckBox';
import timeImg from '../../../../../assets/Icons/timeIcon.svg';
import styles from './index.module.scss';
import {
  AddTubeChartPanelNames, layoutVals, offsetValues, onCLickValues, sectionValues, vesselTopValues,
} from '../../../utils/tubeChartConstant';
import {
  AddTubeChartPanelValues, VanishType,
  VesselTopType,
} from '../../../utils/tubeChartTypes';
import { RootState } from '../../../../../redux/rootState';
import {
  getChartListSuccess,
  setLayout,
  setOffset,
  setRows,
  setScale, setSectionValues, setSelectedSection, setShowLayout, setTubesPerRow, setVanishType, setVesselTop,
} from '../../../redux/tubeChart/tubeChartSlice';
import localStorageConstants from '../../../../../utils/LocalStorageConstants';
import { ANALYST_ROLE_ID } from '../../../../../Routes/constant';
import MultiOffsetConversionConfirmationModal from '../../../../../Common/MultiOffsetConversionConfirmationModal/MultiOffsetConversionConfirmationModal';

interface PanelProps {
  handleUndo:() => void;
  handleSectionChange: (value:string) => void;
  tubeCount: number;
  totalTubeCount: number;
  isUndoDisable: boolean;
  vesselTopVal: string;
}

function AddTubeChartPanel({
  handleUndo, handleSectionChange, tubeCount, totalTubeCount, isUndoDisable, vesselTopVal,
}:PanelProps) {
  const {
    control, formState: { errors }, setValue, watch,
  } = useForm<AddTubeChartPanelValues>();
  const [openConfirmation, setOpenConfirmation] = useState('');
  const [multiValue, setMultiValue] = useState(false);

  const {
    selectedSection, vanishType, relativeCord, sectionValues: secVals,
    scale, showLayout, layout, chartList, offset,
  } = useSelector((state:RootState) => state.TubeChartReducer);
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);

  const dispatch = useDispatch();

  const canZoom = watch(AddTubeChartPanelNames.Zoom);

  const handleVanishChange = (value:string) => {
    dispatch(setVanishType(value as unknown as VanishType));
  };

  useEffect(() => {
    if (chartList.length > 0 && selectedSection) {
      const currentDetails = chartList?.find((details) => details.Panel === selectedSection);
      if (currentDetails) {
        setValue(AddTubeChartPanelNames.Offset, currentDetails?.Offset);
        setValue(AddTubeChartPanelNames.Rows, currentDetails?.NumOfRows);
        setValue(AddTubeChartPanelNames.TubesPerRow, currentDetails?.RowLength);
        setValue(AddTubeChartPanelNames.VesselTop, currentDetails?.VesselTop);
        dispatch(setOffset(currentDetails?.Offset));
        dispatch(setRows(currentDetails?.NumOfRows));
        dispatch(setTubesPerRow(currentDetails?.RowLength));
        dispatch(setVesselTop(currentDetails?.VesselTop as VesselTopType));
      }
    }
  }, [selectedSection, chartList?.length]);

  useEffect(() => {
    setValue(AddTubeChartPanelNames.TubeCount, String(tubeCount || 0));
    setValue(AddTubeChartPanelNames.TotalTubeCount, String(totalTubeCount || 0));
  }, [tubeCount, totalTubeCount]);

  useEffect(() => {
    if (vesselTopVal) {
      dispatch(setVesselTop(vesselTopVal as VesselTopType));
      setValue(AddTubeChartPanelNames.VesselTop, vesselTopVal);
    }
  }, [vesselTopVal, setValue]);

  const handleZoomChange = (value:boolean) => {
    if (value) {
      dispatch(setScale(scale));
    } else {
      dispatch(setScale(1));
    }dispatch(setScale(1));
  };
  const handleMultiOffsetChange = (value: boolean) => {
    if (value) {
      setOpenConfirmation('Are you sure you want to convert this to multi-offset tube chart?');
      setMultiValue(true);
    } else {
      setOpenConfirmation('Are you sure you want to convert this multi-offset tube chart to single-offset. This will loose all the progress made for Section 1 & Section 3.');
      setMultiValue(false);
    }
  };
  const handleCancel = () => {
    if (multiValue) {
      setValue(AddTubeChartPanelNames.IsMulti, false);
    } else {
      setValue(AddTubeChartPanelNames.IsMulti, true);
    }
    setOpenConfirmation('');
  };
  const handleConfirm = () => {
    if (multiValue) {
      dispatch(setSectionValues(sectionValues));
      dispatch(setShowLayout(true));
      dispatch(setLayout('1'));
    } else {
      dispatch(setSectionValues(sectionValues.filter((item) => item?.Value === '2')));
      setValue(AddTubeChartPanelNames.Section, '2');
      dispatch(setSelectedSection('2'));
      dispatch(setShowLayout(false));
      dispatch(setLayout('0'));
      // remove 1, 3 data from chart list
      const filteredChartList = chartList?.filter((item) => item?.Panel === '2');
      dispatch(getChartListSuccess(filteredChartList));
    }
    setOpenConfirmation('');
  };

  useEffect(() => {
    const updatedCharts = chartList?.map((item) => ({
      ...item,
      Layout: layout,
    }));
    dispatch(getChartListSuccess(updatedCharts));
  }, [layout]);

  const disableFields = useMemo(() => {
    if (chartList.find((item) => item?.Panel === selectedSection)) {
      return true;
    } return false;
  }, [chartList, selectedSection]);

  return (
    <div style={{
      background: '#e5f6ee',
      padding: '15px',
      margin: '10px',
      border: '1px solid #00A751',
      borderRadius: '6px',
    }}
    >
      <Grid container spacing={1}>
        <Grid item lg={1.1} md={2} sm={6} xs={12}>
          <div className="div_label_text" style={{ marginLeft: '25px' }}>
            {/* <label className="no_label_Style" /> */}
            <label className="label_Style_Customer noBreakWord">Multi-Offset</label>
            <div style={{ marginTop: '5px' }}>
              <CustomCheckbox
                name={AddTubeChartPanelNames.IsMulti}
                control={control}
                label=""
                errors={errors}
                handleChange={handleMultiOffsetChange}
              />
            </div>
          </div>
        </Grid>
        <Grid item lg={1.1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">Section</label>
            <ComponentSelectInput
              name={AddTubeChartPanelNames.Section}
              control={control}
              defaultValue="2"
              errors={errors}
              size="small"
              handleChange={handleSectionChange}
              entries={secVals}
              className={styles.whiteBackground}
            />
          </div>
        </Grid>
        {showLayout && (
        <Grid item lg={1.1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">Layout</label>
            <ComponentSelectInput
              name={AddTubeChartPanelNames.Layout}
              control={control}
              defaultValue="1"
              errors={errors}
              size="small"
              handleChange={(e) => dispatch(setLayout(e))}
              entries={layoutVals}
              className={styles.whiteBackground}
            />
          </div>
        </Grid>
        )}
        <Grid item lg={1.1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">Offset</label>
            <ComponentSelectInput
              name={AddTubeChartPanelNames.Offset}
              defaultValue={offset || ''}
              control={control}
              errors={errors}
              size="small"
              handleChange={(e) => dispatch(setOffset(e))}
              entries={offsetValues}
              className={styles.whiteBackground}
              disabled={disableFields}
            />
          </div>
        </Grid>
        <Grid item lg={1.1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">Rows</label>
            <ComponentTextInput
              name={AddTubeChartPanelNames.Rows}
              id={AddTubeChartPanelNames.Rows}
              control={control}
              type="number"
              errors={errors}
              size="small"
              handleChange={(e, val) => dispatch(setRows(val))}
              className={styles.whiteBackground}
              isDisable={disableFields}
            />
          </div>
        </Grid>
        <Grid item lg={1.1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">Tubes per row</label>
            <ComponentTextInput
              name={AddTubeChartPanelNames.TubesPerRow}
              id={AddTubeChartPanelNames.TubesPerRow}
              control={control}
              errors={errors}
              type="number"
              size="small"
              handleChange={(e, val) => dispatch(setTubesPerRow(val))}
              className={styles.whiteBackground}
              isDisable={disableFields}
            />
          </div>
        </Grid>
        <Grid item lg={1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">Vessel Top</label>
            <ComponentSelectInput
              name={AddTubeChartPanelNames.VesselTop}
              control={control}
              errors={errors}
              defaultValue={vesselTopVal || ''}
              handleChange={(e) => dispatch(setVesselTop(e as VesselTopType))}
              size="small"
              entries={vesselTopValues}
              className={styles.whiteBackground}
              disabled={disableFields}
            />
          </div>
        </Grid>
        <Grid item lg={1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer">On Click</label>
            <ComponentSelectInput
              name={AddTubeChartPanelNames.OnClick}
              control={control}
              errors={errors}
              defaultValue={vanishType}
              handleChange={handleVanishChange}
              size="small"
              entries={onCLickValues}
              className={styles.whiteBackground}
              disabled={(roleId === ANALYST_ROLE_ID)}
            />
          </div>
        </Grid>
        <Grid item lg={0.8} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer noBreakWord">Tube Count</label>
            <ComponentTextInput
              name={AddTubeChartPanelNames.TubeCount}
              id={AddTubeChartPanelNames.TubeCount}
              isDisable
              control={control}
              errors={errors}
              size="small"
              className={styles.whiteBackground}
            />
          </div>
        </Grid>
        <Grid item lg={0.7} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer noBreakWord">Drawing Size</label>
            <TextField
              size="small"
              fullWidth
              onChange={(e) => {
                const { value } = e.target;
                // logic max zoom capacity
                if (Number(value) < 10 && Number(value) >= 1) {
                  dispatch(setScale(Number(value)));
                }
              }}
              defaultValue={1}
              inputProps={{ step: 0.1 }}
              value={scale}
              id={AddTubeChartPanelNames.Size}
              type="number"
              className={`${styles.whiteBackground}`}
              disabled={!canZoom}
            />
          </div>
        </Grid>
        <Grid item lg={0.7} md={1} sm={3} xs={6}>
          <div className="div_label_text" style={{ marginLeft: '25px' }}>
            {/* <label className="no_label_Style" /> */}
            <label className="label_Style_Customer noBreakWord">Zoom</label>
            <div style={{ marginTop: '5px' }}>
              <CustomCheckbox
                name={AddTubeChartPanelNames.Zoom}
                control={control}
                label=""
                errors={errors}
                handleChange={handleZoomChange}
              />
            </div>
          </div>
        </Grid>
        <Grid item lg={0.5} md={1} sm={3} xs={6}>
          <div className="div_label_text ">
            <label className="no_label_Style" />
            <img
              src={timeImg}
              className={`${isUndoDisable ? styles.arrowDisable : styles.arrowPointer}`}
              alt="icon"
              height={30}
              width={30}
              onClick={handleUndo}
            />
          </div>
        </Grid>
        {!showLayout && <Grid item lg={1.8} md={2} sm={6} xs={12} />}
        {showLayout && <Grid item lg={0.7} md={2} sm={6} xs={12} />}
        <Grid item lg={0.2} md={2} sm={6} xs={12} />
        <Grid item lg={1} md={2} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="label_Style_Customer noBreakWord">Total Tube Count</label>
            <ComponentTextInput
              name={AddTubeChartPanelNames.TotalTubeCount}
              id={AddTubeChartPanelNames.TotalTubeCount}
              isDisable
              control={control}
              errors={errors}
              size="small"
              className={styles.whiteBackground}
            />
          </div>
        </Grid>
        <Grid item lg={1.4} md={3} sm={6} xs={12}>
          <div className="div_label_text">
            <label className="no_label_Style" />
            {relativeCord.x > 0 && relativeCord.y > 0
            && <div className={styles.textStyle}>{`Row ${relativeCord.x}, Tube ${relativeCord.y}`}</div>}
          </div>
        </Grid>
      </Grid>
      {openConfirmation && (
        <MultiOffsetConversionConfirmationModal
          show={openConfirmation}
          setOpenFrom={() => setOpenConfirmation('')}
          handleCancel={handleCancel}
          handleConfirm={handleConfirm}
        />
      )}
    </div>
  );
}

export default AddTubeChartPanel;
